import React from "react";
import styled from "styled-components";
import { Flex } from "grid-styled";
import Icon from "./Icon";
import { CHECK, WARN } from "../icons";
import * as colors from "../settings/colors";

const StyledIcon = styled(Icon)`
  flex: 0 0 24px;
  fill: ${props => props.color};
`;

const Option = ({
  checked,
  checkedStyles = {
    icon: CHECK,
    color: colors.GREEN
  },
  uncheckedStyles = {
    icon: WARN,
    color: colors.ORANGE
  },
  children
}) => {
  return (
    <Flex my="4px">
      <StyledIcon
        icon={checked ? checkedStyles.icon : uncheckedStyles.icon}
        color={checked ? checkedStyles.color : uncheckedStyles.color}
      />{" "}
      <div style={{ paddingLeft: 8, paddingTop: 4, lineHeight: "16px" }}>
        {children}
      </div>
    </Flex>
  );
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/Option.js